import { render, staticRenderFns } from "./scrousel-tabs.vue?vue&type=template&id=997247ac&scoped=true"
import script from "./scrousel-tabs.vue?vue&type=script&lang=js"
export * from "./scrousel-tabs.vue?vue&type=script&lang=js"
import style0 from "./scrousel-tabs.vue?vue&type=style&index=0&id=997247ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997247ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCarouselStep: require('/builds/wj/fe/wenjuan-homesite/components/common/carousel-step.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default})
